import DropdownSelection from 'app/models/dropdown_selection';

const PARAM_KEY = 'description';
const QUERY_PARAMS = {
  '': undefined,
  'tracker.*': ['tracker.created', 'tracker.updated'],
  'batch.*': ['batch.created', 'batch.updated'],
  'scan_form.*': ['scan_form.created', 'scan_form.updated'],
  'insurance.*': ['insurance.purchased', 'insurance.cancelled'],
  'refund.*': ['refund.successful'],
  'report.*': ['report.new', 'report.available', 'report.failed'],
  'payment.*': ['payment.created', 'payment.completed', 'payment.failed'],
  'fulfillment.order.*': ['fulfillment.order.created', 'fulfillment.order.updated'],
};

export default DropdownSelection.extend({
  initialize(options) {
    DropdownSelection.prototype.initialize.apply(
      this, [{
        ...options,
        choices: [
          { option: '', readable: 'All Descriptions' },
          { option: 'tracker.*', readable: 'tracker.*' },
          { option: 'batch.*', readable: 'batch.*' },
          { option: 'scan_form.*', readable: 'scan_form.*' },
          { option: 'insurance.*', readable: 'insurance.*' },
          { option: 'scan_form.*', readable: 'scan_form.*' },
          { option: 'refund.*', readable: 'refund.*' },
          { option: 'report.*', readable: 'report.*' },
          { option: 'payment.*', readable: 'payment.*' },
          { option: 'fulfillment.order.*', readable: 'fulfillment.order.*' },
        ],
        label: 'Description',
        paramKey: PARAM_KEY,
      }],
    );
  },

  getVal() {
    return QUERY_PARAMS[this.get('currentChoice').option];
  },
});



// WEBPACK FOOTER //
// ./app/models/event_description_dropdown_selection.js